import { toothUtils } from '../toothUtils';
import profiler from '@/globals/Profiler';
import { gConsts } from '@/globals/gConsts';

export class InternalLocationsToolBuilder {

    static TOOL_TYPE = gConsts.tool.attrib.types.RETANGULO_INC;
    static TOOL_LAYER = gConsts.layer.locations.TEETH_INTERNAL;

    constructor(jobTools) {
        this.jobTools = jobTools;

        this.randomSeed = Math.floor(Math.random() * 10000)
    }

    _isEligible(toothTool) {
        return toothTool.label.id.startsWith('lb_dente') && toothTool.attrib.type == gConsts.tool.attrib.types.CURVA;
    }

    _buildRegionToolLabel(toothToolLabelId, locationType, regionType) {
        return `${toothToolLabelId}_${locationType}_${regionType}`;
    }

    _buildRegionToolLabelText(toothToolLabelText, locationType, regionType) {
        return `${toothToolLabelText} ${locationType} - ${regionType}`;
    }

    _buildRegionToolId(regionLabel, serial) {
        return `tool_${InternalLocationsToolBuilder.TOOL_TYPE}_${regionLabel}[${serial}]__${this.randomSeed}`;
    }

    _cleanToothInternalCache(toothTool) {
        delete toothTool.coords.longAxis
        delete toothTool.coords.longAxisBaseMandibula
        delete toothTool.coords.longAxisSegment
        delete toothTool.coords.regionPts
        delete toothTool.coords.contourSegment
    }

    buildTools(toothTool) {
        if (!this._isEligible(toothTool))
            return;

        const internalLocationTools = [];
        var serial = 0,
            regionLabel,
            regionTool;

        this._cleanToothInternalCache(toothTool)
        const toothInternalLocations = toothUtils.buildToothInternalLocations(toothTool, this.jobTools);
        profiler.start('create_face_tools')
        profiler.profileBlock('Method', 'InternalLocationsToolBuilder.buildTools', 'create_tool ' + toothTool.label.id, () => {
            for (const [locationType, locationRegions] of Object.entries(toothInternalLocations)) {
                for (const [regionType, regionPts] of Object.entries(locationRegions)) {
                    if (regionPts.length > 0) {
                        regionLabel = this._buildRegionToolLabel(toothTool.label.id, locationType, regionType);
                        regionTool = {
                            id: this._buildRegionToolId(regionLabel, serial++),
                            attrib: {
                                type: InternalLocationsToolBuilder.TOOL_TYPE,
                                iAMethod: gConsts.tool.attrib.iaMethods.NONE,
                            },
                            label: {
                                text: this._buildRegionToolLabelText(toothTool.label.text, locationType, regionType),
                                id: regionLabel,
                                layer: InternalLocationsToolBuilder.TOOL_LAYER,
                                vLabel: { x: 0, y: 0 },
                            },
                            state: {
                                confidence: gConsts.tool.state.confidence.OK,
                                marked: false,
                                input: gConsts.tool.state.inputs.MANUAL
                            },
                            elem: {
                                index: 0,
                            },
                            coords: {
                                pts: regionPts,
                                ptsOriginal: null,
                            },
                            locations: {
                                internal: {
                                    faces: {
                                        list: locationType == 'faces' ? [regionType] : [],
                                        custom: ''
                                    },
                                    portions: {
                                        list: locationType == 'porcoes' ? [regionType] : [],
                                        custom: ''
                                    }
                                }
                            },
                            dente: toothTool.label.id,
                            qualifiers: {
                                list: [],
                                custom: '',
                            },
                        };
                        internalLocationTools.push(regionTool);
                    }

                }
            }
        });
        profiler.end();

        return internalLocationTools;
    }
}